<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("class.behavior") }}</h4>
        </div>
      </md-card-header>
      <div class="text-right mr-10">
        <md-button
          v-if="$can(Behavior.actions.add, Behavior.subject)"
          class="md-success mr-3"
          @click="$emit('addBehavior')"
          >{{ $t("common.add_new") }}</md-button
        >
        <md-button
          class="md-warning"
          @click="exportPdf"
          v-if="tableData.length"
          >{{ $t("student.export_file") }}</md-button
        >
      </div>
      <md-card-content class="overflow-x-auto" v-if="tableData.length">
        <yv-table
          :tableData="tableData"
          :pagination="pagination"
          :columns="columns"
          :hideNoNumber="true"
          :hideBulkAction="true"
          :sort-data="sortData"
          :tableActionsComponent="TableActions"
        >
        </yv-table>
        <div class="flex items-center justify-end" v-if="tableData.length">
          <Pagination
            :value="currentPage"
            :perPage="20"
            :total="totalData"
            @input="changePage"
          />
        </div>
      </md-card-content>
      <md-card-content v-else class="min-h-[300px]">
        <no-data-found></no-data-found>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import { service_paths, service_names } from "@/constants/Services";
import Swal from "sweetalert2";
import NoDataFound from "@/components/Base/Illustration/NoDataFound";
import { Behavior } from "@/constants/Permissions";
import { Message } from "@/helpers/utils";
import Pagination from "@/components/Pagination";
import YvTable from "@/components/Base/YvTable";
import TableActions from "./TableActions";
import moment from "moment";
export default {
  components: { NoDataFound, Pagination, YvTable },
  props: ["isActiveTab"],
  data() {
    return {
      student: {},
      tableData: [],
      columns: {
        term: "common.term",
        datetime_violate: "behavior.datetime_violate",
        submitted_by: "behavior.submitted_by",
        alignment: "behavior.alignment",
        event: "schedule.event"
      },
      pagination: {
        hidePerPageOptions: true
      },
      sortData: {
        currentSort: "id",
        currentSortOrder: "desc"
      },
      TableActions,
      defaultStartPage: 1,
      Behavior,
      currentPage: 1,
      totalData: 0,
      isActive: false
    };
  },
  computed: {
    studentId() {
      return this.$route.params.id;
    }
  },
  watch: {
    isActiveTab: function(newVal) {
      if (this.isActive) return;
      if (newVal) {
        this.fetchBehavior();
        this.isActive = true;
      }
    }
  },
  methods: {
    fetchBehavior() {
      this.$axios
        .get(`${service_paths.behavior}`, {
          student_id: this.studentId,
          page: this.currentPage,
          limit: 20
        })
        .then(response => {
          this.tableData = response.data.data.map(item => ({
            ...item,
            term: item.term?.name,
            datetime_violate: moment(item.date_violate).format(
              "DD/MM/YYYY HH:mm"
            )
          }));
          this.totalData = response.data.total;
        });
    },
    exportPdf() {
      this.$axios
        .get(
          `${service_names.utility}/behavior/${this.studentId}/export-pdf`,
          undefined,
          undefined,
          undefined,
          "blob"
        )
        .then(response => {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "behavior.pdf");
            document.body.appendChild(link);
            link.click();
            link.remove();
            Message.success(this.$t("behavior.export_success"));
          } else {
            Message.error(this.$t("common.an_error_occurred"));
          }
        });
    },
    viewBehavior(item) {
      this.$emit("viewBehavior", item);
    },
    confirmDeleteBehavior(id) {
      Swal.fire({
        title: this.$t("common.are_you_sure"),
        text: this.$t("behavior.delete_title"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.yes_delete_it"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteBehavior(id);
        }
      });
    },
    deleteBehavior(id) {
      this.$axios.delete(`${service_paths.behavior}/${id}`).then(() => {
        Message.success(this.$t("common.delete_success"));
        this.fetchBehavior();
      });
    },
    changePage(val) {
      this.currentPage = val;
      this.fetchBehavior();
    }
  },
  provide() {
    return {
      viewBehavior: this.viewBehavior,
      deleteBehavior: this.confirmDeleteBehavior
    };
  }
};
</script>
<style lang="scss" scoped></style>
